export function resolveApiHostForBrowser(rawApiUrl: string | undefined, isDev: boolean): string {
  const apiUrl = rawApiUrl?.trim() ?? "";
  if (!isDev || apiUrl.length === 0) {
    return apiUrl;
  }

  return isLoopbackUrl(apiUrl) ? "" : apiUrl;
}

function isLoopbackUrl(apiUrl: string): boolean {
  try {
    const url = new URL(apiUrl);
    return url.hostname === "localhost"
      || url.hostname === "127.0.0.1"
      || url.hostname === "[::1]";
  } catch {
    return false;
  }
}
